export default __webpack_public_path__ + "static/media/not-found-image.5c2ea420.png";